/* eslint-disable react/prop-types */

const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "");

export const getPrintTemplate = ({ headerInfo, rows, totals }) => {
  // 1. Render các dòng phát sinh trong kỳ (Items)
  const rowsHtml = rows
    .map(
      (row) => `
      <tr>
        <td class="text-center">${row.documentNumber || ""}</td>
        <td class="text-center">${row.documentDate || ""}</td>
        <td>${row.description || ""}</td>
        <td class="text-right">${fmt(row.paidVatAmount)}</td>
        <td class="text-right">${fmt(row.payableVatAmount)}</td>
      </tr>
    `
    )
    .join("");

  // 2. Render toàn bộ template HTML
  return `
    <html>
      <head>
        <title>In Sổ Theo Dõi Thuế GTGT</title>
        <style>
          @media print {
            @page { margin: 15mm; size: portrait; }
            body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
          }
          body {
            font-family: "Times New Roman", Times, serif;
            color: #000;
            padding: 0;
            margin: 0;
            font-size: 13px;
          }
          .header-top { display: flex; justify-content: space-between; margin-bottom: 20px; }
          .title-box { text-align: center; margin: 30px 0 20px 0; }
          .title-main { font-size: 18px; font-weight: bold; margin: 0; text-transform: uppercase; }
          
          table { width: 100%; border-collapse: collapse; margin-top: 15px; font-size: 13px; }
          th, td { border: 1px solid #000; padding: 6px; }
          th { text-align: center; font-weight: bold; vertical-align: middle; }
          
          .text-center { text-align: center; }
          .text-right { text-align: right; }
          .bold { font-weight: bold; }
          .italic { font-style: italic; }
          
          .row-highlight td { font-weight: bold; background-color: #fafafa !important; }
          
          .footer-info { margin-top: 20px; line-height: 1.6; }
          .signature-section { display: flex; justify-content: space-between; margin-top: 30px; text-align: center; }
          .signature-box { width: 33%; }
          .signature-space { height: 70px; }
          
          .note-section { margin-top: 40px; font-size: 13px; }
        </style>
      </head>
      <body>
        <div class="header-top">
          <div style="width: 45%;">
            <div class="bold" style="margin-bottom: 5px;">Đơn vị: ${
              headerInfo.company || ".............................."
            }</div>
            <div class="bold">Địa chỉ: ${
              headerInfo.companyAddress || ".............................."
            }</div>
          </div>
          <div style="text-align: center; width: 55%;">
            <div class="bold">Mẫu số S61-DN</div>
            <div class="italic" style="font-size: 13px; margin-top: 4px;">
              (Kèm theo Thông tư số 99/2025/TT-BTC <br /> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)
            </div>
          </div>
        </div>

        <div class="title-box">
          <h2 class="title-main">SỔ THEO DÕI THUẾ GIÁ TRỊ GIA TĂNG</h2>
          <div class="bold" style="margin-top: 10px;">
            Năm: ${headerInfo.year || "..............."}
          </div>
        </div>

        <table>
          <thead>
            <tr>
              <th colspan="2" style="width: 20%;">Chứng từ</th>
              <th rowspan="2" style="width: 40%;">Diễn giải</th>
              <th rowspan="2" style="width: 20%;">Số tiền thuế<br />GTGT đã nộp</th>
              <th rowspan="2" style="width: 20%;">Số tiền thuế<br />GTGT phải nộp</th>
            </tr>
            <tr>
              <th style="width: 10%;">Số hiệu</th>
              <th style="width: 10%;">Ngày, tháng</th>
            </tr>
            <tr style="background-color: #f0f0f0 !important;">
              <th>A</th>
              <th>B</th>
              <th>C</th>
              <th>1</th>
              <th>2</th>
            </tr>
          </thead>
          <tbody>
            <tr class="row-highlight">
              <td></td>
              <td></td>
              <td>- Số dư đầu kỳ</td>
              <td class="text-right">${fmt(headerInfo.openingPaidVatAmount)}</td>
              <td class="text-right">${fmt(headerInfo.openingPayableVatAmount)}</td>
            </tr>

            <tr>
              <td></td>
              <td></td>
              <td class="bold">- Số phát sinh trong kỳ:</td>
              <td></td>
              <td></td>
            </tr>

            ${rowsHtml}

            <tr class="row-highlight">
              <td></td>
              <td></td>
              <td>- Cộng số phát sinh</td>
              <td class="text-right">${fmt(totals?.totalArisingPaidVatAmount)}</td>
              <td class="text-right">${fmt(totals?.totalArisingPayableVatAmount)}</td>
            </tr>

            <tr class="row-highlight">
              <td></td>
              <td></td>
              <td>- Số dư cuối kỳ</td>
              <td class="text-right">${fmt(totals?.closingPaidVatAmount)}</td>
              <td class="text-right">${fmt(totals?.closingPayableVatAmount)}</td>
            </tr>
          </tbody>
        </table>

        <div class="footer-info">
          <div>- Sổ này có <span class="bold">${
            headerInfo.totalPages || "....."
          }</span> trang, đánh số từ trang 01 đến trang...</div>
          <div>- Ngày mở sổ: ${headerInfo.openingDate || ".............................."}</div>
        </div>

        <div class="signature-section">
          <div class="signature-box">
            <div class="bold">Người ghi sổ</div>
            <div class="italic">(Ký, họ tên)</div>
            <div class="signature-space"></div>
            <div>${headerInfo.preparerName || ""}</div>
          </div>
          <div class="signature-box">
            <div class="bold">Kế toán trưởng</div>
            <div class="italic">(Ký, họ tên)</div>
            <div class="signature-space"></div>
            <div>${headerInfo.chiefAccountantName || ""}</div>
          </div>
          <div class="signature-box">
            <div class="italic" style="margin-bottom: 4px;">
              Ngày ${headerInfo.signingDay || "..."} tháng ${
    headerInfo.signingMonth || "..."
  } năm ${headerInfo.signingYear || "..."}
            </div>
            <div class="bold">Người đại diện theo pháp luật</div>
            <div class="italic">(Ký, họ tên, đóng dấu)</div>
            <div class="signature-space" style="height: 50px;"></div>
            <div>${headerInfo.legalRepresentativeName || ""}</div>
          </div>
        </div>

        <div class="note-section">
          <span class="bold italic">Ghi chú:</span> Sổ này áp dụng cho các doanh nghiệp tính thuế GTGT phải nộp theo phương pháp trực tiếp
        </div>

        <script>
          // Tự động gọi lệnh in khi cửa sổ load xong
          window.onload = function() {
            setTimeout(() => {
              window.print();
            }, 500); // Thêm delay nhỏ để CSS kịp load trước khi in
          };
        </script>
      </body>
    </html>
  `;
};
